import React from 'react';

function MarkerIcon({ width = 15, height = 18, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 15 18">
      <g>
        <path d="M7.18082101,10.903 C5.11482101,10.903 3.43882101,9.227 3.43882101,7.162 C3.43882101,5.095 5.11482101,3.421 7.18082101,3.421 C9.24582101,3.421 10.921821,5.095 10.921821,7.162 C10.921821,9.227 9.24582101,10.903 7.18082101,10.903 M13.583821,3.948 C12.322821,1.446 9.79682101,0 7.15782101,0 C6.07782101,0 4.97682101,0.229 3.94382101,0.757 C0.385821011,2.525 -0.991178989,7.001 0.752821011,10.398 C1.80882101,12.487 5.87782101,17.377 5.87782101,17.377 C6.58182101,18.222 7.72882101,18.218 8.42782101,17.369 C8.42782101,17.369 12.459821,12.464 13.583821,10.398 C14.686821,8.379 14.640821,6.037 13.583821,3.948" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default MarkerIcon;
